export default "__VITE_ASSET__Dc5dfAk3__"